import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate';
import { BasicSelect } from 'vue-search-select';
import ZoneListing from './../zonelisting';
import Pagination from './../../../../shared/components/pagination'
import MasterService from './../../../services/masterdata.service';
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'create-zone',
  components: {
    BasicSelect,
    ZoneListing,
    Pagination,
    VueElementLoading
  },
  props: ['selectedZone'],
  data: function() {
    return {
      isLoading: false,
      showaddform: true,
      showlist: false,
      username: '',
      zone: '',
      zonename: '',
      accordianTab:{1:false, 2:false, 3:false},
      stateregionlist: [],
      stateregionchk: [],
      currentSelectedStates:[],
      SelectedStates:[],
      StateLoading: false,
      citystateregionlist: [],
      citystateregionchk: [],
      CityLoading: false,
      chkAllCity: false,
      basecitycheck: '',
      ErrorMsg: ''
    }
  },
  computed: {

  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata');
		var userToken = window.localStorage.getItem('userToken');
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
    this.username = userdetail.email;
		await this.getStateList();
    if(this.selectedZone.id){
      this.id = this.selectedZone.id;
      this.getZoneDetails();
    }
  },
  methods: {
    expandAll(){
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll(){
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid){
      this.expanded = false;
			for (var key in this.accordianTab) {
				if(tabid != key){
					this.accordianTab[key] = false;
				}
			}
		},
    showList() {
      this.$emit("goBackToParent")
    },
    dataLoad(val){
      if(this.currenttab == val){
      }else if(val==2){
        this.currenttab = val;
        if(this.currentSelectedStates!=this.SelectedStates){
          this.getCityList();
        }
      }else if(val==3){
        let res = this.citystateregionchk.some(item => item['cityid'] === this.basecitycheck.cityid);
        if(!res) {
          this.basecitycheck = "";
        }
      }else{
        this.currenttab = val;
      }
    },
    onStateChange(){
      let temp = [];
      for(var i =0; i<this.stateregionchk.length; i++){
        temp.push(this.stateregionchk[i].stateid);
      }
      this.SelectedStates = temp;
      const uniqueStateIds = [...new Set(this.citystateregionchk.map(item => item.stateid))];
      if(uniqueStateIds.length >0){
        let filteredArray = this.citystateregionchk;
        for(var k=0; k <uniqueStateIds.length; k++){
          if(this.SelectedStates.includes(uniqueStateIds[k])){
          }else{
            filteredArray = this.citystateregionchk.filter(obj => obj.stateid !== uniqueStateIds[k])
          }
        }
        this.citystateregionchk = filteredArray;
      }
    },
    removeSelectedState(index, data) {
      this.stateregionchk.splice(index, 1);
      this.onStateChange();
    },
    async getStateList() {
      this.stateregionlist = [];
      this.isLoading = true;
      this.StateLoading = true;
      try {
        let result = await MasterService.getStateList();
        this.stateregionlist = result.data.data;
        this.StateLoading = false;
        this.isLoading = false;
      } catch (err) {
        this.StateLoading = false;
        this.isLoading = false;
        console.log(err);
      }
    },
    getStateName(state) {
      for (var i = 0; i < this.stateregionlist.length; i++) {
        if (this.stateregionlist[i].stateid == state) {
          return this.stateregionlist[i].statename;
        }
      }
    },
    getStateObj(state){
      for (var i = 0; i < this.stateregionlist.length; i++) {
        if (this.stateregionlist[i].stateid == state) {
          return this.stateregionlist[i];
        }
      }
    },
    getStateRegion(state){
      for (var i = 0; i < this.stateregionlist.length; i++) {
        if (this.stateregionlist[i].stateid == state) {
          return this.stateregionlist[i].region;
        }
      }
    },
    selectAllCity(){
      if(this.chkAllCity==true){
        let temArr = [];
        this.CityLoading = true;
        for(var i=0; i <this.citystateregionlist.length; i++){
          temArr.push({
            cityid: this.citystateregionlist[i].cityid,
            cityname: this.citystateregionlist[i].cityname,
            stateid: this.citystateregionlist[i].stateid,
            statename: this.citystateregionlist[i].statename
          });
        }
        this.citystateregionchk = temArr;
        this.CityLoading = false;
      }else{
        this.citystateregionchk = [];
      }
    },
    async getCityList(action, state) {
      try {
        if (action == 'edit') {
          this.SelectedStates = state;
        }
        if (this.stateregionchk.length > 0) {
          this.citystateregionlist = [];
          this.CityLoading = true;
          let inputPayload = {
            "stateId": this.SelectedStates
          }
          let result = await MasterService.getCityList(inputPayload);
          this.citystateregionlist = result.data.data;
          this.currentSelectedStates = this.SelectedStates;
          this.onCityChange();
          this.CityLoading = false;
        }else{
          this.citystateregionlist=[];
          this.citystateregionchk=[];
        }
      } catch (err) {
        this.CityLoading = false;
        console.log(err);
      }
    },
    getCityName(city) {
      for (var i = 0; i < this.citystateregionlist.length; i++) {
        if (this.citystateregionlist[i].cityid == city) {
          return this.citystateregionlist[i].cityname;
        }
      }
    },
    removeSelectedCity(index, data) {
      this.chkAllCity= false;
      this.citystateregionchk.splice(index, 1);
      this.onCityChange();
    },
    onCityChange(){
      this.chkAllCity= false;
      let res = this.citystateregionchk.some(item => item['cityid'] === this.basecitycheck.cityid);
      if(!res) {
        this.basecitycheck = "";
      }
    },
    getBaseCityName(basecity) {
      for (var i = 0; i < this.citystateregionlist.length; i++) {
        if (this.citystateregionlist[i].cityid == basecity) {
          return this.citystateregionlist[i].cityname;
        }
      }
    },
    onSubmit: function() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        } else {
          this.saveZoneDetails();
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    async saveZoneDetails() {
      try {
        const uniqueStateIds = [...new Set(this.citystateregionchk.map(item => item.stateid))];
        if (this.stateregionchk.length == 0) {
          this.ErrorMsg = 'Please select State'
          return false;
        } else if (this.citystateregionchk.length == 0) {
          this.ErrorMsg = 'Please select City'
          return false;
        } else if (this.basecitycheck == '') {
          this.ErrorMsg = 'Please select Base City'
          return false;
        } else if(this.SelectedStates.length!=uniqueStateIds.length){
          let difference = this.SelectedStates.filter(x => !uniqueStateIds.includes(x));
          let tempArr = [];
          for(var k=0; k<difference.length; k++){
            tempArr.push(this.getStateName(difference[k]));
          }
          this.ErrorMsg = 'Please select at least one City for Selected States: '+tempArr.join(", ");
          return false;
        }
        else {
          this.ErrorMsg = "";
          let inputPayload = {};
          if(this.id){
            inputPayload.id = this.id;
          }
          inputPayload.zoneid = this.zone.trim();
          inputPayload.zonename = this.zonename.trim();

          var regiondata = this.stateregionlist.filter(obj => obj.stateid == this.basecitycheck.stateid);
          inputPayload.basecity = this.basecitycheck.cityid;
          inputPayload.masterregion = regiondata[0].region;
          inputPayload.createdby = this.username;
          inputPayload.statecount = this.stateregionchk.length;
          inputPayload.citycount = this.citystateregionchk.length;
          inputPayload.statecitydata = this.citystateregionchk;
          this.isLoading = true;
          let result = await MasterService.saveZoneDetails(inputPayload);
          this.isLoading = false;
          if (result.data.code == 200) {
            this.$alert(result.data.message, this.zonename, "success");
            this.$emit("goBackToParent");
          }else{
            this.$alert(result.data.message, this.zonename, "error");
          }
        }
      } catch (err) {
        this.isLoading = false;
        this.$alert(err, "Territory", "error");
        console.log(err);
      }
    },
    async getZoneDetails(){
      try {
        let InputPayload = {
          zoneid: this.id
        }
        this.isLoading = true;
        let response = await MasterService.getZoneDetailsById(InputPayload);
        let zoneDetails = response.data.data;
        var state = [];
        var city = [];
        this.zone = zoneDetails.cargozoneid;
        this.zonename = zoneDetails.cargozonename;
        this.masterregion = zoneDetails.master_region;
        for (var i = 0; i < zoneDetails.cargozonestatecities.length; i++) {
          state.push(zoneDetails.cargozonestatecities[i].stateid);
          city.push(zoneDetails.cargozonestatecities[i].cityid);
          this.citystateregionchk.push({
            "cityid": zoneDetails.cargozonestatecities[i].cityid,
            "cityname": zoneDetails.cargozonestatecities[i].cityname,
            "stateid": zoneDetails.cargozonestatecities[i].stateid,
            "statename": zoneDetails.cargozonestatecities[i].statename,
          });

          if(zoneDetails.base_city == zoneDetails.cargozonestatecities[i].cityid){
            this.basecitycheck = {
              cityid: zoneDetails.base_city,
              stateid: zoneDetails.cargozonestatecities[i].stateid
            }
          }
        }
        let tempArr = state.filter((v,i) => state.indexOf(v) == i);

        let tempStateArr = [];
        for(var i=0; i<tempArr.length; i++){
          tempStateArr.push(this.getStateObj(tempArr[i]));
        }
        this.stateregionchk = tempStateArr;
        await this.getCityList('edit', tempArr);
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/zone/createzone/createzone.component.js